import { render, staticRenderFns } from "./SlowNetworkTip.vue?vue&type=template&id=25f50462&scoped=true&"
import script from "./SlowNetworkTip.vue?vue&type=script&lang=js&"
export * from "./SlowNetworkTip.vue?vue&type=script&lang=js&"
import style0 from "./SlowNetworkTip.vue?vue&type=style&index=0&id=25f50462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f50462",
  null
  
)

export default component.exports